<template>
  <v-container
    v-if="length > 1 && !loading"
    class="app-pagination white pa-2 mb-0"
    fluid
    grid-list-xl
  >
    <v-layout 
      row
      wrap
      align-center
    >
      <v-pagination
        :value="currentPagination"
        :length="length"
        :total-visible="totalVisible"
        @input="onPagination"
        color="primary"
        class="elavation-0"
        flat
      />
      <v-text-field
        id="pagination-input"
        v-model="goToPage"
        @input="debouncePagination"
        name="pagination-input"
        placeholder="Página"
        mask="#########"
      />
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from 'lodash'

export default {
  name: 'AppPagination',
  props: {
    loading: Boolean,
    length: {
      type: Number,
      default: null
    },
    currentPagination: {
      type: Number,
      default: 1
    }
  },
  data: () => ({
    totalVisible: 6,
    goToPage: ''
  }),
  methods: {
    onPagination(page) {
      this.goToPage = ''
      this.$emit('onPagination', Number(page))
    },
    debouncePagination: debounce(function() {
      if (this.goToPage && this.goToPage <= this.length) {
        this.onPagination(this.goToPage)
      }
    }, 2000)
  }
}
</script>

<style lang="stylus">
.v-pagination__navigation,
.v-pagination__item
  &:focus
    outline: 0px
.app-pagination
  .v-text-field
    max-width: 51px
  #pagination-input
    text-align: center
</style>
